import React from "react";
import { Link } from "@/components/catalyst/link";
import { Tag } from "@/components/ui/tag";
import { format, parseISO } from "date-fns";

interface WritingCardProps {
  title: string;
  subtitle: string;
  tag?: string;
  date: string;
  link: string;
}

const WritingCard: React.FC<WritingCardProps> = ({
  title,
  subtitle,
  tag,
  date,
  link,
}) => {
  const parseDate = parseISO(date);
  const formattedDate = format(parseDate, "dd MMM yyyy");
  return (
    <Link
      key={link}
      href={link}
      className="-m-2 flex flex-col items-start gap-2 rounded-2xl p-2 hover:bg-stone-100 hover:opacity-100 dark:hover:bg-stone-800"
    >
      <div className="flex w-full items-center justify-start gap-2">
        {tag && <Tag>{tag}</Tag>}
        <span className="text-foreground flex w-max justify-start text-sm leading-6 font-light uppercase">
          {formattedDate}
        </span>
      </div>
      <div className="flex h-full flex-col">
        <div className="flex w-full items-start justify-between gap-2">
          <header className="text-foreground-700 mr-2 block pb-2 text-lg leading-tight font-bold text-balance">
            {title}
          </header>
        </div>
        <p className="text-foreground">{subtitle}</p>
      </div>
    </Link>
  );
};

export default WritingCard;
